<template>
  <div style="margin-top: 50px">
    <div class style="margin-top: 50px">
      <div class="has-ribbon">
        <div class="ribbon is-large is-warning">Video</div>
      </div>
      <h1 class="subtitle has-text-grey radha-thero">
        <font-awesome-icon icon="video" />
        පූජ්‍ය කන්දේකුඹුරෙ රාධ ස්වාමීන්වහන්ස විසින් දේශිත ධර්ම දේශනා
      </h1>
      <hr class="is-divider" data-content="අමාදොර" />

      <div
        class="columns is-multiline"
        style="margin-left: 50px; margin-right: 50px"
      >
        <div
          v-for="video in videos"
          :key="video.id"
          class="column is-one-fifth-fullhd is-one-quarter-desktop is-one-third-tablet"
          data-aos="zoom-in-up"
          data-aos-delay="800"
          data-aos-duration="1000"
        >
          <div class="card">
            <div class="card-image is-1by1">
              <youtube :video-id="video.id" height="200hv" width="100%" />
            </div>
            <div class="card-content">
              <div class="subtitle has-text-grey is-5">{{ video.title }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped></style>

<script>
export default {
  data() {
    return {
      videos: [
        {
          id: "xaUvBIib-Cs",
          title: "මහා වෙස්සන්තර දේශනාව (1)"
        },
        {
          id: "nPmaetbegMA",
          title: "මහා වෙස්සන්තර දේශනාව (2)"
        },
        {
          id: "m688_ZVcbYM",
          title: "සිල් සුවදෙහි රැදි දෙලොව දිනන මග"
        },
        {
          id: "vqW029chmJ4",
          title: "පස්සද්ධි සම්බොජ්ඣංග"
        },
        {
          id: "JuJKGb42MQs",
          title: "ධම්මවිචය සම්බොජ්ඣංගය"
        },
        {
          id: "IsxgAL4sXJU",
          title: "සති සම්බොජ්ඣංගය"
        },
        {
          id: "n3MG7gSr4is",
          title: "විරිය සම්බොජ්ඣංග"
        },
        {
          id: "O_o5EjuNjEg",
          title: "ප්‍රීති සම්බොජ්ඣංග"
        },
        {
          id: "IMqKAEHV9Qc",
          title: "ව්‍යග්ඝපජ්ජ සුත්‍රය"
        },
        {
          id: "Wqt7Qk09HSg",
          title: "පුඤ්ඤාභිසන්ද"
        },

        {
          id: "FSlE-uY2qCA",
          title: "සෝමාවතී මහ සෑ වරුණ"
        },
        {
          id: "b9qCZ3wAtEI",
          title: "නිමි ජාතක දේශනාව"
        },
        {
          id: "QE5JsYUPAp4",
          title: "ඨාන සූත්‍රය"
        },
        {
          id: "MN7C7uFJ-vA",
          title: "ප්‍රඥා ධර්ම දේශනාව"
        },
        {
          id: "8-7mnc3lE54",
          title: "ධර්ම සාකච්ඡාව 02"
        }
      ]
    };
  }
};
</script>
